import React, { useEffect } from "react";
import {
    Layout,
    Row,
    Col,
    Divider,
    Form,
    Button,
    Input
} from "antd";
import { Content } from "antd/lib/layout/layout";
import { openNotification } from "../../../../utils/Notifactions";

export default function EvaluaarProyectoFormNotaModelForm(props: any) {

    console.log(props)

    useEffect(() => {
        if (props.modalType === 'add') {
            let edit: any = props.editData
            edit.no = props.updateData?.length + 1
        } else if (props.modalType === 'edit') {
            let edit: any = props.editData
            edit.no = props.updateData?.length + 1
        }
    }, [props.editData])
    // console.log('aqui estan', props.dataArray);

    // console.log('este es el id: ', props.dataArray[0].id)
    // console.log('otro por si a caso CASO 2', props.dataArray.map((dato: any) => dato.id))

    const handleButtonModal = async (e: any) => {

        if(props.editData.nota > props.dataArray[0].porcentaje ){
            return openNotification({
                titulo: "Error",
                descripcion: "No se puede asignar una nota superior al puntaje del criterio",
                placement: "bottomRight",
              });
        }

        if(props.editData.observaciones == "" || props.editData.observaciones == null ){
            return openNotification({
                titulo: "Error",
                descripcion: "La observación es obligatoria",
                placement: "bottomRight",
              });
        }

        props.setEditFormModel(false)
        if (props.modalType === 'add') {


            (props.dataArray?.length >= 0 ? props.dataArray : []).splice(props.editData)
            props.setUpdateData([
                ...(props.updateData ?? []),
                props.editData,
            ])
            await props.putCriterios()
        } else {
            await props.putCriterios()
        }
        props.hanldeClick(e)
    }

    return (
        <div>
            <div>
                <Layout
                    className="mb-2 model_info"
                    style={{ borderRadius: "15px", background: 'white', width: '100%' }}
                >
                    <Content className='model__header pb-0 btm_border' style={{paddingLeft: 20, paddingTop:14, paddingRight:20, }}>
                        <Content className='mdl_header_containt'>
                                <div className='col-9 p-0 mb-2 mt-0 font-size-16px font-family-Montserrat-SemiBold'>
                                    Evaluar criterio
                                </div>
                        </Content>
                    </Content>
                    <div className="col-12 ps-4 pe-4"><Divider className="m-0"/></div>
                    <Content className="evalu__top_mdl_box">
                        <Content className="evalu_inform_header" style={{paddingLeft: 20, paddingTop:20, paddingRight:20, }}></Content>
                        {props.dataArray.map((data: any,i) => (
                            <Content key={i} className="eval_cat_form_text form_paddin" style={{paddingLeft: 20, paddingRight:20, }}>
                                <p className='cat_title'>
                                    <span className="color-label">Criterio:</span><br/><span className="font-size-14px font-family-Montserrat-Regular"> {data.nombre}</span>
                                </p>

                                <p className='cat_title'>
                                    <span className="color-label">Descripción:</span><br/>
                                    <span className="font-size-14px font-family-Montserrat-Regular">{data.descripcion}</span>
                                </p>
                            </Content>
                        ))}
                        <Content className="evalu_cat_form" style={{paddingLeft: 20, paddingTop:20, paddingRight:20, }}>
                            <label className="color-label">Nota de evaluación</label>
                            <Form className="evalu__form">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label className="color-label-regular">Observaciónes - <small>Obligatorio</small></label>
                                        <Input.TextArea
                                            placeholder=""
                                            className="evl_cat_input"
                                            value={props?.editData?.observaciones}
                                            onChange={(e) => {
                                                props.setEditData({
                                                    ...props?.editData,
                                                    observaciones: e.target.value,
                                                })
                                            }}
                                            style={{ marginTop: 10 }}
                                            rows={15}
                                            maxLength={1000}
																						required={true}
                                        />
                                    </div>
                                    {props.dataArray.map((data: any,i) => (
                                        <div key={i} className="col-12 col-md-3">
                                            <label className="color-label-regular">Puntaje ( 0-{data.porcentaje} )</label>
                                            <Input
                                                placeholder={props.modalType === 'edit' ? data.nota : ''}
                                                max={data.porcentaje}
                                                min='0'
                                                type='number'
                                                className="evl_cat_input"
                                                value={props?.editData?.nota}
                                                onChange={(e) => {
                                                    props.setEditData({
                                                        ...props?.editData,
                                                        nota: e.target.value,
                                                        id: props.dataArray[0].id,
                                                    })
                                                }}
                                                style={{ marginTop: 10 }}
                                            />
                                        </div>
                                    ))}
                                    {props.dataArray.map((data: any,i) => (
                                        <div key={i} className="col-12 col-md-3">
                                            <label className="color-label-regular">Puntaje máx.</label>
                                            <Input
                                                placeholder="20%"
                                                className="evl_cat_input"
                                                value={data.porcentaje}
                                                onChange={(e) => {
                                                    props.setEditData({
                                                        ...props?.editData,
                                                        porcentaje: e.target.value,
                                                    })
                                                }}
                                                style={{ marginTop: 10, fontWeight: 'bold' }}
                                                disabled
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Form>
                        </Content>
                        <div className="col-12 mt-4"><Divider className="m-0"/></div>
                        <Content className="mt-2 mb-2 me-4">
                            <div className="row">
                                <div className="col-12 form--btm-btn-box d-flex justify-content-end">
                                    <Button

                                        onClick={(e) => handleButtonModal(e)}
                                        className="btn-submit button-azul-radius order-1"
                                        type="primary"
                                    >
                                        {props.modalType === 'add' ? 'EVALUAR CRITERIO' : 'GUARDAR CAMBIOS'}
                                    </Button>
                                    <Button
                                        onClick={() => (props.setEditFormModel(false))}
                                        style={{ border: 'none' }}
                                        className="form_bg_btn button-gray-ghost me-4 order-0"
                                    >
                                        CANCELAR
                                    </Button>
                                </div>
                            </div>
                        </Content>
                    </Content>
                </Layout>
            </div>
        </div >
    );
}